// 统一请求路径前缀在libs/axios.js中修改
import { getRequestIP,postRequestIP } from '@/libs/axios';
let hostUrl = 'https://ipapi.qh-copyright.cn'
// let hostUrl = ''

// sts
export const getStsA = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/sts', params)
}

// 登录
export const gettokenLogin = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/web/mobile/gettoken', params)
}


// 获取标签
export const getIplabels = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/ip/labels', params)
}
// 获取专题(主题展)
export const getSpecials = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/specials/h5', params)
}

// 获取获取轮播图
export const getSlideshow = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/slideshow', params)
}

// 列表数据
export const getIplist2 = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/ip/list2', params)
}

// 点赞
export const setLike = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/set/like', params)
}

// 详情
export const idDetail = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/ip/detail', params)
}

// 提交IP需求
export const xuqueEnter = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/enter', params)
}
export const xuqueDemand = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/demand', params)
}

// 主题展
export const getSpecialsh5 = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/specials/h5', params)
}

// 提交ip
export const ipOrder = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/ip/order', params)
}

// 提交ip列表
export const userOrderList = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/user/order', params)
}

// 提交ip详情
export const userOrderDetail = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/order/detail', params)
}
// 取消ip
export const cancelOrder = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/cancel/order', params)
}
// 相关文件
export const orderFile = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/order/file', params)
}

// 2022-4-11 add
// 搜索
export const onSearch = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/ip/search', params)
}

// 搜索主题
export const onSearchSpecial = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/specials/list', params)
}

// 
export const specialsSub = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/specials/sub', params)
}
export const specialsSubrelated = (params) => {
    return postRequestIP( hostUrl + '/ipshuttle/get/specials/sub/related/list', params)
}
